import {ReactNode} from "react";
import {
    HStack,
    Text,
    Avatar,
    Box,
    CloseButton,
    SkeletonCircle,
    VStack,
    Skeleton,
    useDisclosure
} from "@chakra-ui/react";
import {FaUserFriends} from "react-icons/fa";
import {CustoMenu, ConfirmationModal, Description, L5Button} from "../UI";
import {RequestAction} from "../../models";
import {requestMessages} from "../../helper/utils";

type Props = {
    loading?: boolean
    title: string
    subtitle?: ReactNode
    onAction: (v: RequestAction) => void
}

function Placeholder(p: {onClick?: VoidFunction}) {
    return <HStack gap={4}>
        <SkeletonCircle size="10"/>
        <VStack spacing={1} align="start" w="full">
            <Skeleton
                h="16px"
                w={{ base: "120px", md: "250px" }}
                borderRadius="md"
            />
            <Skeleton
                h="12px"
                w={{ base: "150px", md: "300px" }}
                borderRadius="md"
            />
        </VStack>
        {p.onClick && <CloseButton onClick={p.onClick}/>}
    </HStack>
}

export function MessageHeader(p: Props) {
    const modal = useDisclosure();
    const view = () => p.onAction({type: "view_infos"});
    const close = () => p.onAction({type: "close"});
    const action = () => modal.onOpen();
    function cancel() {
        modal.onClose();
        p.onAction({type: "cancel"});
    }
    return <HStack
        p={3}
        bg="gray.100"
        h={{base: "auto", md: "72px"}}
        borderBottom="1px solid #ddd"
        _hover={{cursor: "pointer"}}
    >
        <ConfirmationModal
            isOpen={modal.isOpen}
            onClose={modal.onClose}
            description={<Description {...requestMessages.cancellation}/>}
        >
            <L5Button type="secondary" onClick={modal.onClose}>
                Keep Request Open
            </L5Button>
            <L5Button onClick={cancel} type="primary">
                Cancel Request
            </L5Button>
        </ConfirmationModal>
        {p.loading && <Placeholder onClick={close} />}
        {!p.loading && <HStack flex="2 4 auto" gap={4} maxW="90%" position="relative">
            <Avatar icon={<FaUserFriends/>}/>
            <Box className="stack" maxW="80%">
                <Text
                    className="one-line pre-x-click"
                    fontWeight="bold"
                    textTransform="capitalize"
                    onClick={view}
                >
                    {p.title}
                </Text>
                {p.subtitle}
            </Box>
        </HStack>}
        <CustoMenu
            placement="bottom-end"
            items={[
                {action: view, content: "Request details", icon: "info"},
                {action, content: "Cancel request", icon: "slash_circle"},
                {action: close, content: "Close chat", icon: "x_circle"},
            ]}
        />
    </HStack>;
}
